import { BaseWalletConnect } from './client';
import type { WalletConnectConfig } from './types';

// Registry backend the SDK reads /connect/wallets from; a dApp overrides via `apiUrl`/`registryUrl`.
const FAMILY_API_URL = 'https://family-api.toncorp.io';

// walletId must match the `connect_wallets` registry row for the family-wallet personal wallet.
export class FamilyWalletConnect extends BaseWalletConnect {
  constructor(config: Omit<WalletConnectConfig, 'walletId'>) {
    super({ ...config, walletId: 'family-wallet', apiUrl: config.apiUrl ?? FAMILY_API_URL });
  }
}
